import "./IndianRegistrationNumber.css";
import { useEffect } from "react";
import { GoabFormItem, GoabBlock, GoabInput, GoabSpacer } from "@abgov/react-components";
import { onlyNumberKey } from "../../utils/globalUtility"; 

const IndianRegistrationNumber = ({ form, getResourceValue, setFormData }) => {
  useEffect(() => {
    onlyNumberKey("band");
    onlyNumberKey("position");
    onlyNumberKey("family");
  }, []);

  const handleBlur = (name) => {
    form.setFieldTouched(name, true);
  }

  const handleChange = (name, value) => {
    delete form.errors[name]
    form.setFieldValue(name, value);
    if (setFormData) {
      const formValue = {...form.values, [name]: value};
      setFormData(formValue);
    }
  };

  return (
    <GoabBlock>
      <div>
        <div className="label regular">
          {getResourceValue({
            key: "RESOURCES@form.indianRegistrationNumber.label",
          })}
          <em> (all fields are optional)</em>
        </div>
        <GoabSpacer vSpacing="m"/>
        <GoabBlock gap="xs">
          <div>
            <GoabFormItem
              label={getResourceValue({
                key: "RESOURCES@form.indianRegistrationNumber.band.label",
              })}
              helpText={getResourceValue({
                key: "RESOURCES@form.indianRegistrationNumber.band.help_text",
              })}
              error={
                form.errors.band &&
                form.touched.band &&
                getResourceValue({ key: form.errors.band })
              }
            >
              <GoabInput
                name="band"
                id="band"
                onBlur={({name}) => handleBlur(name)}
                onChange={({ name, value }) => handleChange(name, value)}
                maxLength={3}
                width="10ch"
                value={form.values.band}
                error={
                  form.errors.band &&
                  form.touched.band &&
                  getResourceValue({ key: form.errors.band })
                }
              ></GoabInput>
            </GoabFormItem>
          </div>
          <div>
            <GoabFormItem
              label={getResourceValue({
                key: "RESOURCES@form.indianRegistrationNumber.family.label",
              })}
              helpText={getResourceValue({
                key: "RESOURCES@form.indianRegistrationNumber.family.help_text",
              })}
              error={
                form.errors.family &&
                form.touched.family &&
                getResourceValue({ key: form.errors.family })
              }
            >
              <GoabInput
                name="family"
                id="family"
                onBlur={({name}) => handleBlur(name)}
                onChange={({name, value}) => handleChange(name, value)}
                maxLength={5}
                width="10ch"
                value={form.values.family}
                error={
                  form.errors.family &&
                  form.touched.family &&
                  getResourceValue({ key: form.errors.family })
                }
              ></GoabInput>
            </GoabFormItem>
          </div>
          <div>
            <GoabFormItem
              label={getResourceValue({
                key: "RESOURCES@form.indianRegistrationNumber.position.label",
              })}
              helpText={getResourceValue({
                key: "RESOURCES@form.indianRegistrationNumber.position.help_text",
              })}
              error={
                form.errors.position &&
                form.touched.position &&
                getResourceValue({ key: form.errors.position })
              }
            >
              <GoabInput
                name="position"
                id="position"
                onBlur={({name}) => handleBlur(name)}
                onChange={({name, value}) => handleChange(name, value)}
                maxLength={2}
                width="5ch"
                value={form.values.position}
                error={
                  form.errors.position &&
                  form.touched.position &&
                  getResourceValue({ key: form.errors.position })
                }
              ></GoabInput>
            </GoabFormItem>
          </div>
        </GoabBlock>
      </div>
    </GoabBlock>
  );
};

export default IndianRegistrationNumber;
